<template>
  <div class="rt-table-dropdown">
    <div v-if="hasIcon" class="rt-table-dropdown-icon">
      <rt-icon :name="icon" :size="14" />
    </div>
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="rt-table-dropdown-content" @click="dropdownClick">
        <p class="rt-table-dropdown-title">{{ menuList[selected].name }}</p>
        <rt-icon
          :name="showMore ? 'rt-base-angle_up' : 'rt-base-angle_down'"
          size="18"
          color="#143E81"
        />
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in menuList"
          :icon="item.icon"
          :key="index"
          :command="index"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'RtTableDropdown',
  props: {
    icon: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showMore: false,
      selected: this.value
    };
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    }
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    }
  },
  methods: {
    dropdownClick() {
      this.showMore = !this.showMore;
    },
    handleCommand(val) {
      this.showMore = false;
      this.$emit('input', val);
    }
  }
};
</script>
<style lang="less" scoped>
.rt-table-dropdown {
  display: flex;
  align-items: center;
  .rt-table-dropdown-icon {
    background: #0099ff;
    color: #fff;
    border-radius: 2px;
    margin-right: 10px;
    height: 24px;
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    .rt-icon {
      line-height: 1;
    }
  }
  .rt-table-dropdown-content {
    display: flex;
    align-items: center;
    .rt-table-dropdown-title {
      font-size: 15px;
      color: #143e81;
      font-weight: 500;
      margin-right: 9px;
      height: 18px;
      line-height: 18px;
    }
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    font-size: 15px;
    color: #143e81;
  }
}
</style>



// WEBPACK FOOTER //
// rtTableDropdown.vue?21c96ccc